import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import { useEffect, useState } from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import {
  GTM_CLICK_EVENT,
  getEventUserType,
  sendGTMBasicPageViewEvent,
  sendGTMCustomClickEvent,
} from '../../../../helpers/gtmHelper'
import apis from '../../../../modules/apis'
import { axiosGet, axiosPost } from '../../../../modules/axiosHelper'
import { useCurrentUser } from '../../../../modules/context/UserContext'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import { n_common, n_review, s_review } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { STUDENT_BTN_ID, STUDENT_PAGE_VIEW_ID } from '../../../../modules/ids/gtm/student'
import urls from '../../../../modules/urls'
import { IconCircle } from '../../../_legacy/RadioGroupComponent'
import { useBasicPopup } from '../../../basic/popup/BasicPopup'
import { useConfirmPopup } from '../../../basic/popup/ConfirmPopup'
import LoadingSpinner from '../../../common/LoadingSpinner'

interface ILessonEvaluationReport {
  lessonId: number
  refetch?: any
  lessonData: any
  onClose: any
}

interface IReportList {
  title: string
  id: number
  refetch: () => void
}
const LessonEvaluationReport = ({ lessonId, refetch, lessonData, onClose }: ILessonEvaluationReport) => {
  const { t, locale } = useTranslation()
  console.log(lessonData, 'lessonData')
  const router = useAppRouter()
  const basicPopup = useBasicPopup()
  const confirmPopup = useConfirmPopup()
  const { currentUser } = useCurrentUser()

  const [selectedReport, setSelectedReport] = useState<number>(0)
  const [reportDescription, setReportDescription] = useState<string>('')
  const [reportList, setReportList] = useState<IReportList[]>([])
  const [submitLoading, setSubmitLoading] = useState<boolean>(false)

  const getLessonReviewUrl = (response: { success?: boolean }, isClassroom: boolean, lessonId: number) => {
    if (isClassroom) {
      return urls.student.newPortal.lessons.reviews.home + '?update=evaluation'
    }

    if (response?.success) {
      return urls.student.newPortal.lessons.reviewDetail.asFeedback(lessonId) + '&update=evaluation'
    }

    return urls.student.newPortal.lessons.reviews.home + '?update=evaluation'
  }

  /**
   * Sends a custom click event to Google Tag Manager (GTM) with the given parameters.
   *
   * @param {string} buttonName - The name of the clicked button.
   */
  const sendClickEventToGTM = (buttonName: string) => {
    const eventType = GTM_CLICK_EVENT.CLICK_BUTTON_NEW
    const buttonId = STUDENT_BTN_ID.CLICK_INCOMPLETE_LESSON_REPORT_SUBMIT_BUTTON
    const eventUserType = getEventUserType(currentUser)
    const eventName = 'Lesson Evaluation Modal'
    const pagePath = router.asPath
    const payload = { lesson_id: lessonId }

    sendGTMCustomClickEvent(eventType, buttonId, buttonName, eventUserType, eventName, pagePath, payload)
  }

  const submitReport = async (routerPath: string, lessonId: number, categoryId: number, content: string) => {
    const isClassroom = routerPath.includes('/lessons/classroom/')
    setSubmitLoading(true)
    const handleRightBtn = async () => {
      const response = await axiosGet(apis.lessons.review.feedback(lessonId, 'score'))
      const url =
        currentUser?.upcoming_lesson_count == 0 && currentUser?.unused_coupons > 0
          ? urls.student.newPortal.lessons.upcomingLessons
          : getLessonReviewUrl(response, isClassroom, lessonId)

      //복습 목록 페이지
      if (!isClassroom) {
        basicPopup.close('lesson-report-sorry-popup')
        basicPopup.close('lessons-report-popup')

        refetch && refetch()
        return
      }
      router.push(url)
    }

    try {
      sendClickEventToGTM('리포트 제출 버튼')

      const response = await axiosPost(apis.lessons.issueReport(lessonId), {
        category_id: categoryId,
        content,
        id: lessonId,
      })
      if (response) {
        basicPopup.show({
          id: 'lesson-report-sorry-popup',
          maxW: 464,
          body: (
            <div>
              <div className="Headline3-22Bd">{t(n_review.report.modal_title)}</div>
              <div className="Body1-16Md mt-[12px] mb-[40px]">{t(n_review.report.modal_desc)}</div>
              <div className="">
                <DSButton
                  onClick={() => handleRightBtn()}
                  type={BUTTON_TYPE.SOLID}
                  size={BUTTON_SIZE.LG}
                  isLoading={submitLoading}
                >
                  <DSButton.Label>{t(n_common.btn_confirm)}</DSButton.Label>
                </DSButton>
              </div>
            </div>
          ),
          // onRightBtnClick: handleRightBtn,
        })
      }
    } catch (error) {
      console.log(error, 'error')
    } finally {
      setSubmitLoading(false)
    }
  }

  const fetchReportCategories = async () => {
    try {
      const response = await axiosGet(apis.lessons.issueReportCategories())
      return response
    } catch (e) {
      console.log(e)
      throw e
    }
  }

  useEffect(() => {
    fetchReportCategories()
      .then((response) => {
        setReportList(response)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [])

  useEffect(() => {
    sendGTMBasicPageViewEvent(
      STUDENT_PAGE_VIEW_ID.PORTAL_INCOMPLETE_LESSON_REPORT,
      getEventUserType(null),
      locale,
      'Incomplete Lesson Report Modal',
      router.asPath,
      { lesson_id: lessonId }
    )
  }, [])

  const isAvailableSubmit = selectedReport && selectedReport > 0
  return (
    <div>
      <div className="Headline2-24Bd mb-[24px]">{t(n_review.report.title(lessonData.tutor.name))}</div>
      <div className="h-[290px]">
        {reportList.length === 0 && <LoadingSpinner sm show primary />}
        {reportList.map((report) => (
          <div
            key={report.id}
            className="border-b-1 flex flex-row items-center justify-between px-[20px] pt-[17px] pb-[19px] text-[14px]"
            onClick={() => setSelectedReport(report.id)}
          >
            <div>{t(report.title)}</div>
            <div>
              <IconCircle checked={report.id === selectedReport} disabled={false} />
            </div>
          </div>
        ))}
      </div>
      <div className="mt-[24px]">
        <div className="text-[16px] font-bold">{t(s_review.subtitle_report)}</div>
        <div className="flex">
          <TextareaAutosize
            style={{ fontSize: 14, borderRadius: '5px' }}
            className="Body2-14Md mt-[24px] w-full resize-none border-0 bg-gray-50 px-[16px] py-[16px] text-gray-400 focus:outline-none focus:ring-0"
            onChange={(e) => {
              setReportDescription(e.target.value)
            }}
            value={reportDescription}
            minRows={3}
            placeholder={t(s_review.placeholder_optional)}
          />
        </div>
      </div>

      <div className="mt-[36px] flex justify-end gap-[8px]">
        <div className="sm:h-[46px] sm:w-[112px]">
          <DSButton size={BUTTON_SIZE.MD} type={BUTTON_TYPE.OUTLINE} onClick={() => onClose()}>
            <DSButton.Label>{t(n_common.btn_leave)}</DSButton.Label>
          </DSButton>
        </div>
        <div className="sm:h-[46px] sm:w-[112px]">
          <DSButton
            size={BUTTON_SIZE.MD}
            type={BUTTON_TYPE.SOLID}
            disabled={!isAvailableSubmit}
            onClick={() =>
              isAvailableSubmit && submitReport(router?.asPath, lessonId, selectedReport, reportDescription)
            }
          >
            <DSButton.Label>{t(n_review.step_4.btn_2)}</DSButton.Label>
          </DSButton>
        </div>
      </div>
    </div>
  )
}

export default LessonEvaluationReport
